export default {
  activities: "活动",
  home: "首页",
  version: "版本",
  save: "保存",
  new: "新增",
  edit: "编辑",
  delete: "删除",
  add: "添加",
  update: "更新",
  change: "修改",
  remove: "移除",
  clear_list: "清空列表",
  selected: "选择",
  description: "描述",
  remark: "备注",
  related: "相关的",
  attachments: "附件",
  bom_name: "BOM名称",
  actions: "操作",
  associate: "关联",
  date: "日期",
  taxed: "含税",
  title: "标题",
  version_number: "版本号",
  quantity: "数量",
  log_message: "日志信息",
  pdf_download: "下载PDF",
  pdf_generate: "生成PDF",
  related_pdf: "相关PDF",
  amount: "金额",
  currency: "货币",
  is_tax_included: "是否含税?",
  error: "错误",
  save_success_message: "信息保存成功！",
  loading: "加载中...",
  currency_exchange_rate_tooltip: "CNY-USD汇率。",
  exchange_rate: "CNY-USD汇率",
  non_tax: "未税",
  has_tax: "含税",
  logout: "退出",
  links: "链接",
  open: "打开",
  complete: "完成",
  completed: "已完成",
  categorize: "分类",
  male: "男",
  female: "女",
  unknown: "未知",
  go: "提交",
  created_at: "创建时间",
  confirm: "确定",
  or: "或",
  select: "选择",
  type: "类型",
  option: "选项",
  not_available: "没有可用信息",
  product_form: "产品配置",
  pricing_form: "定价属性",
  thumb: "缩略图",
  technical_data: "技术数据",
  unpublished: "未发布",
  published: "已发布",
  view: "查看",
  trade_type: {
    export: "出口",
    domestic: "国内"
  },
  empty_data: "没有数据",
  menu: {
    home: "首页",
    home_title: "首页",
    quotes_title: "报价",
    projects: "项目",
    files_title: "文件",
    reports_title: "报表",
    quote: {
      title: "报价",
      quote_list: "报价单",
      list_title: "报价单",
      new_quote: "新增报价",
      edit_quote: "编辑报价",
      cost_estimator: "成本估算器",
      overview: "报价预览",
      price_quotation_page: "预览报价单",
      pdf_generate: "生成PDF",
      document: "生成PDF",
      estimate_quotes_group_list: "估价组合",
      new_estimate_quotes_group: "新增估价组合",
      priced_quotes_group_list: "定价组合",
      new_priced_quotes_group: "新增定价组合",
      edit_estimate_quotes_group: "编辑估价组合信息",
      edit_priced_quotes_group: "编辑定价组合信息",
      margin_setting: {
        title: "利润设置",
        historyTitle: "利润设置历史"
      },
      estimate_number: "报价单号",
      new_item: "新增",
      automatic_generated_item: "自动生成行项",
      switch_price: "价格配置",
      download_price_quotation: "下载报价单",
      edit_price_quotation: "编辑报价单",
      workflow: "工作流程",
      configure_workflow: "工作流程",
      tip: "未选择产品或未进行工作流程配置",
      delete_tip: "确认删除此行项么？"
    },
    product: {
      title: "产品",
      new_product: "新增产品信息",
      edit: "编辑产品信息",
      edit_product: "编辑产品信息",
      product_list: "产品"
    },
    project: {
      title: "项目",
      create_project: "创建项目",
      manage_projects: "管理项目",
      info: "项目信息"
    },
    people: {
      list_title: "人员资料",
      detail: "人员信息",
      new: "新增人员信息",
      sync_people: "同步钉钉"
    },
    bom: {
      upload: "通过上传文件导入 BOM",
      upload_map: "绑定上传文件数据",
      preview: "编辑 BOM 结构",
      review: "查看原始 BOM",
      bom_list: "BOMs",
      look_bom: '查看BOM',
      edit_bom: '编辑BOM'
    },
    companies: {
      title: "公司",
      list: "公司列表"
    },
    contacts: {
      title: "联系人",
      list: "联系人列表"
    },
    account: {
      title: "客户",
      list: "客户",
      edit_account: '编辑客户'
    },
    part: {
      title: "料件",
      all: "全部",
      list_page: {
        title: "料件"
      },
      edit: {
        title: "编辑料件信息"
      },
      new: {
        title: "新增电子料件"
      },
      compositions: "Compositions",
      part_overview: "预览料件信息",
      part_usage: "料件使用情况",
      part_migration_history: "料件迁移历史"
    },
    pcb: {
      list_title: "电路光板",
      edit: "编辑",
      new_pcb: "新建"
    },
    electronic_part: {
      list_title: "电子料件",
      edit: "编辑",
      new: "新建"
    },
    mechanical_part: {
      list_title: "结构料件",
      edit: "编辑",
      new: "新建"
    },
    assembled_part: {
      list_title: "PCBA，成品和半成品",
      edit: "编辑",
      new: "新建"
    },
    user: {
      title: "用户",
      my_profile: "我的信息",
      my_tasks: "我的任务"
    },
    estimators: {
      title: '成本估算器',
      assembled_part_cost: '成品、半成品',
      assembled_part_cost_children: '料件',
      assembled_part_costed_bom: '成本结构分析',
      pcb_cost: 'PCB 成本估算器',
      pcb: 'PCB',
      pcb_specifications: '电路板规格参数',
      international_logistics: '国际物流',
      supplier_component_prices: '供应商询价',
      purchased_parts_cost: '料件成本'
    },
    quality: {
      title: "质量数据",
      scrap: {
        title: "损耗率"
      }
    },
    message: {
      title: "消息中心"
    },
    order: {
      list_title: "订单",
      detail: "订单信息",
      new: "新订单"
    }
  },
  form: {
    save: "保存",
    edit: "编辑",
    change: "修改",
    return: "返回",
    cancel: "取消",
    ok: "确定",
    note: '备注',
    select_bom_version: "选择 BOM 版本",
    select_version_source: "选择比较来源",
    item: "行项",
    cost: "单价",
    qty: "数量",
    amount: "总价",
    tax: "税款",
    summary: "合计",
    scrap_amount: "质量成本",
    bom: {
      name: "BOM名称",
      version: "版本",
      product: "产品",
      note: "记录日志",
      part_number: "料号",
      part: "料件",
      setting: {
        load_global_mutual_substitutes: "预加载通用替代料",
        update_item_using_part_attributes: "使用料件属性更新BOM行项",
        bom_type: "BOM类型",
        use_octopart_as_source: "使用Octopart作为数据源"
      }
    },
    quote_item: {
      title: "描述",
      item_type: "类型",
      assocated_model: "关联",
      source: "来源",
      unit_cost: "单位成本",
      note: "备注",
      quantity: "数量",
      volume: "数量",
      margin_value: "利润",
      margin_percent: "利润百分比",
      tax_rate: "税率",
      price_has_tax: "价格是否含税？",
      price: "价格"
    },
    pcb_specifications: {
      board_name: "Board name",
      m_unit: "M. Unit",
      solider_mask: "Solider mask",
      legend_color: "Legend color",
      dimension: "Dimension",
      surface_finished: "Surface finished",
      layers: "Layers",
      copper_weight: "Copper weight",
      pcb_puzzle: "PCB puzzle",
      min_hole_sizes: "Min. Hole sizes",
      materials: "Materials",
      min_trance_space: "Min. Trace/Space",
      finished_thickness: "Finished thickness"
    }
  },
  confirm_delete_image_info: "确认删除这个图片么？",
  new_quote_desc: "Generates a cost for the BOM.",
  bom_tool: {
    edit: {
      upload: {
        skip: "跳过",
        next: "下一步",
        done: "完成",
        alreadyDone: "已经提交",
        reupload: "重新上传",
        tip: "点击或拖动文件到这里来上传",
        download_template: "下载模板",
        advenced: "高级选项",
        header_row: "表头所在行"
      },
      map_col: {
        level: "层级",
        line_quantity: "数量",
        specification: "技术参数",
        designator: "位号",
        mpn: "MPN",
        chinese_name: "中文名称",
        name: "名称",
        brand: "原厂名称（品牌）",
        case_package: "封装",
        unit_name: "单位",
        part_number: "NexPCB 料号",
        type: "类型",
        preferred_status: "推荐",
        notes: "备注",
        editor_note: "编辑备注",
        row_index: "行号",
        title: "选择参数对应的列",
        preview_title: "上传文件前 10 行预览",
        note: "备注",
        part_alias: "别名",
        version: "版本"
      },
      error: {
        empty: "还没有上传文件",
        length: "上传的文件没有足够多的列",
        return: "请重新上传"
      },
      history: {
        prev: "撤销",
        next: "重做"
      },
      move: {
        move: "移动",
        modal_title: "批量移动",
        modal_input: "移动为以下行的子项："
      },
      edit_scrap_model_title: "修改BOM损耗率",
      button_save_and_update_scrap: "保存并更新料件通用损耗率",
      scrap: "损耗率(%)",
      note: "备注"
    },
    review: {
      actions: {
        export: "导出"
      },
      diff: {
        added: "已新增",
        deleted: "已删除",
        modified: "已修改",
        ignored: "已忽略"
      },
      version_select: "版本："
    },
    assembled_bom: {
      version: "子BOM版本",
      view: "查看子BOM",
      customer_provided_tooltip: '该料件为客供料'
    },
    migration: {
      pangu_bom: "工程BOM",
      erp_boms: "ERP中生产BOM",
      select_version: "选择BOM版本",
      notes: "同步建议",
      current: "最新版本",
      start_migration: "开始同步",
      start_migration_note: "开启同步会为当前选择的版本创建新的母件和新的生产BOM,是否开启？",
      erp_bom_is_reviewed: "已复核",
      erp_bom_version_matched_exist: "ERP中存在相同版本生产BOM,无需同步,但是请确保ERP中的生产BOM与工程BOM的一致性",
      erp_bom_exist_but_not_matched_version: "在ERP中存在生产BOM, 但是版本与工程BOM的不一致",
      erp_bom_exist_but_not_matched_version_option_1: "1. 如果不需要生成新的母件和生产BOM,请不要同步,请核对ERP中生产BOM的料件清单，在ERP中完成修改，并将生产BOM版本设置正确",
      erp_bom_exist_but_not_matched_version_option_2: "2. 如果启动同步，在ERP中会创建新的母件和生产BOM，并与当前行的版本对对应上",
      create_new_bom_and_version: "可以开启同步脚本，将当前版本的工程BOM同步到ERP，创建生产BOM",
      parent_product: "母件",
      version: "版本",
      part_number: "料件编号",
      name: "名称",
      erp_state: "ERP状态",
      sync_state: "同步状态"
    },
    version: {
      version: "版本",
      compare_source: "比较源",
      compare_version: "比较版本",
      button_compare: "比较"
    },
    action_buttons: {
      review_changes_since_uploaded: '与原始上次BOM进行对比',
      add_part: '新增料件',
      download_bom: '下载BOM',
      download_template: '下载BOM模板',
      bom_navigator: 'BOM导航',
      upload_bom: '上传BOM',
      edit_imported_bom: '编辑导入的BOM',
      to_edit_bom: '编辑BOM',
      to_compare_bom: 'BOM版本比较'
    },
    version_number: "版本号",
    new_bom: "新建BOM",
    delete_bom_confirm_dialog_title: "删除确认",
    edit_bom_info: "编辑BOM信息",
    delete_confirmation: "你确定要删除这个BOM吗？",
    delete_bom_item_confirm: "你确定要删除吗？",
    synchronize_bom_to_erp: "同步至ERP",
    synchronize_bom_to_erp_warning: "BOM正在编辑中，只有生成版本的BOM才能同步到ERP。",
    synchronize_bom_to_erp_confim: "确认同步BOM至ERP",
    new_version: "新建版本",
    bom_version_number_placeholder: "输入3位版本号，比如，1.0.9.",
    log_message: "日志信息",
    log_message_placeholder: "输入描述说明自上个版本以来所做的变更内容，比如，变更A料件为B料件。",
    create_new_version: "创建新版本",
    current_version: "当前版本",
    part_is_required: "料件是必填项。",
    load_parts_from_octopart: "从Octopart匹配料件",
    export_bom: "导出BOM",
    revisions: "版本历史",
    release: "发布",
    add_part: "添加料件",
    alternatives: "替代料",
    more: "更多",
    qty: "数量",
    unit: "单位",
    name: "名称",
    part_number: "料件编号",
    specification: "规格",
    mfr_part_number: "MPN",
    mfr_name: "原厂名称（品牌）",
    designator: "位号",
    status: "状态",
    actions: "操作",
    manufacturer_part: "关联料件",
    reference_manufacturer_part_link_title: "点击查看关联料件。",
    is_assembly: "是组装件（有BOM）",
    item_name: "行项名称（英文）",
    item_name_cn: "行项名称（中文）",
    note: "备注",
    bom_item_form_drawer_title: "BOM行项",
    release_revision_and_log: "发布版本和日志说明",
    current_state: "当前状态",
    editing: "正在编辑",
    versioned: "已发布",
    latest_version: "最新版本",
    manufacturer_part_name: "料件名称",
    created_at: "创建时间",
    delete_item_confirmation_text: "你确定要删除这个BOM行项吗？",
    suppliers: "供应商",
    quality_data: "质量数据",
    files: "文件",
    item_name_is_required: "行项名称是必填项。",
    item_name_cn_is_required: "行项名称（中文）是必填项。",
    specification_is_required: "规格是必填项。",
    line_quantity_is_required: "数量是必填项。",
    unit_name_is_required: "用量单位是必填项。",
    manufacturer_part_select_help: "选择一个料件将会自动填充以下属性。",
    bom_setting: "BOM设置",
    engineer: "工程师",
    name_is_required: "BOM名称是必填项。",
    assembled_manufacturer_part_is_required: "成品、半成品料件是必填项。",
    engineer_is_required: "工程师是必填项。",
    cost_estimation_using_purpose_bom_desc: "此类型BOM将只能用于报价估价。",
    engineering_bom: "工程BOM",
    cost_estimation_use: "估价使用",
    bom_type_is_required: "BOM类型是必填项。",
    prosecutor_code_message: {
      BOM_ASSOCIATED_PART_HAS_NO_PART_NUMBER: "BOM关联的料件半成品没有编号。",
      BOM_ITEM_MISSING_ASSOCIATED_MANUFACTURER_PART: "BOM中存在行项关联料件缺失。",
      BOM_ITEMS_MISSING_PART_NUMBER: "BOM中存在料件没有料件编号。",
      BOM_ITEM_MODERATION_STATUS_DRAFT: "BOM中存在行项关联料件的状态为编辑状态。",
      BOM_HAS_NO_ITEMS: "BOM没有内容。",
      BOM_NOT_ASSOCIATED_WITH_PART: "BOM母件信息未关联到料件。",
      BOM_CHILDREN_BOM_MISSING_VERSION: "BOM中存在子BOM仍是编辑状态的版本。",
      BOM_ITEM_MISSING_PROPERTIES: "BOM中存在行项信息不完整（名称、规格、单位和数量）。",
      BOM_ITEM_DESIGNATOR_QUANTITY_MISMATCH: "BOM中存在行项位号描述和数量不匹配。",
      ERP_CURRENT_BOM_VERSION_NOT_FOUND_BUT_FOUND_OTHER_RELATED_VERSIONS: "未找到该版本，但是发现其他版本。",
      ERP_BOM_VERSION_NOT_FOUND: "未找到该版本或者其他相关版本。",
      ERP_BOM_VERSION_FOUND: "该版本已存在。",
      BOM_ITEM_MODERATION_STATUS_INVALID: "BOM中存在行项为无效的料件。"
    },
    add_alternate_part: "添加替代料",
    show_similar_parts: "显示相似料件",
    preferred_status: "选择优先级",
    preferred: "优先",
    alternate: "替代",
    manufacturer_part_number: "原厂编号/MPN",
    manufacturer_name: "原厂名称/品牌",
    moderation_state: "编辑状态",
    lifecycle_status: "生命周期状态",
    description: "描述",
    similar_parts_by_octopart: "相似料件由Octopart提供",
    current_bom_only: "仅同于当前BOM",
    global_substitute: "应用到全局替代料（不影响已有BOM设置）",
    global_substitute_setting: "全局替代料设置",
    search_part: "搜索料件"
  },
  companies: {
    name: "名称",
    aliases: "别名",
    website: "网站",
    name_placeholder: "填写公司名称",
    website_placeholder: "填写公司网站",
    aliases_placeholder: "输入后回车添加别名",
    add_alias: "添加",
    has_alias: "已有此别名",
    tags: "标签",
    search: "搜索公司...",
    searching: "搜索中...",
    no_result: "没有结果",
    new: "新增公司",
    actions: "操作",
    edit_company: "编辑公司：",
    add_company: "新增公司",
    confirm_tip: "确认删除 ",
    confirm_button: "确认",
    filter: {
      on: "启用过滤",
      off: "关闭过滤"
    }
  },
  contact: {
    name: "姓名",
    firstname: "名",
    lastname: "姓",
    email: "电子邮件",
    phone: "电话",
    alias: "别名",
    status: "状态",
    job_title: "职称",
    description: "描述",
    address: "街道地址",
    city: "城市",
    state: "状态",
    postal_code: "邮政编码",
    country: "国家",
    firstname_placeholder: "输入联系人名字",
    lastname_placeholder: "输入联系人姓氏",
    email_placeholder: "输入联系邮箱",
    contact_phone_placeholder: "输入联系电话",
    alias_placeholder: "输入联系人别名",
    status_placeholder: "选择联系状态",
    job_title_placeholder: "输入联系人的职位",
    description_placeholder: "输入有关联系人的简要说明",
    address_placeholder: "输入联系人的街道地址",
    city_placeholder: "输入联系人所在城市",
    state_placeholder: "输入联系人的状态",
    postal_code_placeholder: "输入联系人的状态",
    add_alias: "添加",
    has_alias: "此别名已添加",
    tags: "标签",
    search: "搜索联系人...",
    searching: "正在搜索...",
    no_result: "没有结果",
    new: "增加联系人",
    actions: "行动",
    edit_contact: "更改联系资料",
    contact_form: "联系方式",
    add_contact: "增加联系人",
    confirm_tip: "确认删除",
    confirm_button: "确认",
    filter: {
      on: "打开过滤器",
      off: "关闭过滤器"
    },
    status_select: {
      active: "积极的",
      inactive: "不活跃"
    },
    load_contacts: "加载触点",
    associated_company: {
      remove_modal: {
        title: "将公司与联系人分离",
        warning: "此联系人将不再与该公司关联。",
        confirm: "你想继续吗？",
        button_text: "是的，继续"
      }
    },
    search_contact: {
      modal_title: "从 hubspot 加载联系人",
      search_placeholder: "输入联系人名字进行搜索..."
    },
    info: {
      contact_created: "联系人已成功保存"
    }
  },
  part: {
    title: "料件",
    list: {
      title: "电子料件"
    },
    component_change_histories: "料件变更记录",
    substitution: {
      type: "替代类型",
      current: "当前",
      mutually: "通用替代",
      unilateral: "仅可替代当前",
      L1: "通用替代, 替代料B可以和当前料件A互相替代,B的通用替代(L1)关系中也有A",
      L2: "降级替代, 更优参数的替代料B可以替代当前料件A, 但是A不能用于替代B, 且B的降级替代(L2)关系中没有A"
    },
    info: {
      qc_properties: {
        need_examine: "需要检验",
        default_examine_solution: "检验方案"
      },
      purchase_properties: {
        moq: "MOQ",
        mpq: "MPQ",
        english_name: "英文名称",
        base_increase: "增购基数",
        purchase_days: "采购提前期",
        standard_cost: "标准成本",
        major_supplier: "主供应商",
        unit: "单位",
        is_taxed: "是否含税"
      },
      part_number: "料件编号",
      english_name: "英文名称",
      name: "名称",
      case_package: "封装",
      chinese_name: "中文名称",
      mpn: "原厂编号（MPN）",
      brand: "原厂名称（品牌）",
      specification: "规格",
      description: "描述",
      part_type: "料件类型",
      msl: "MSL",
      moderation: "编辑状态",
      lifecycle_status: "生命周期状态",
      lifecycle_status_standard: "标准（大多数标准件）",
      lifecycle_status_custom: "NSF（非标件）",
      require_quality_exam: {
        field_name: '需要质检',
        yes: '是的',
        no: '不'
      },
      unit: "单位",
      category: "分类",
      units: {
        pcs: "pcs",
        batch: "批",
        unit: "个",
        set: "台",
        suit: "套",
        roll: "卷",
        kg: "千克"
      },
      ensure_part_is_reviewed_and_category_set: "确保料件状态为发布状态（Reviewed）且分类已设置正确。"
    },
    specification_alert: "请在以下规格参数表单中修改，保存后规格将会自动生成",
    similar_parts: "相似料件",
    alternatives: "替代关系",
    spec_property_values: "规格参数",
    similar_parts_empty_result: "未找到相似规格料件。",
    part_spec_add_fail_tip: "该规格参数已存在！！！",
    part_spec_add_success_tip: "添加成功！！！",
    part_spec_save_tip: "保存成功！",
    search_placeholder: "输入料件编号或者MPN查询",
    customer_information: '供料客户',
    mutual_substitute: "通用替代关系",
    unilateral_substitute: "高阶替代关系",
    substitute_manage: "管理",
    part_search_input_placeholder: "输入料件编号、名称、规格或者MPN等进行查询...",
    merge_mututal_substitute_collections_confirm: "发现重叠的通用替代集合，是否合并？",
    merge: "合并！",
    substitute_collections_merged_success: "已完成合并！",
    manage_part_substitutes: "管理料件替代关系",
    assembled_part: "成品、半成品料件"
  },
  project: {
    create_project_match_deal_placeholder: "Enter order number to search a deal...",
    field_project_name_input_placeholder: "Enter project name...",
    field_project_name_label: "Project Name",
    empty_deal_message: "Enter a order number above to load deal information!",
    button_save_and_create_quote: "Save and Create Quote",
    info_sections: {
      deal: {
        title: "交易"
      },
      order: {
        title: "订单"
      },
      quote: {
        title: "报价"
      },
      bom: {
        title: "BOM"
      },
      gerber: {
        title: "Gerber"
      }
    }
  },
  part_number_form: {
    generate_part_number_btn: "生成料件编号",
    save_part_number_btn: "保存料件编号",
    remove_part_number_btn: "删除料件编号",
    click_enter_pn_help_text: "点击输入料件编号",
    concat_text_or: "或",
    cancel_btn: "取消",
    enter_part_number: "输入料件编号进行更新或者创建...",
    remove_confirm_message: "你确定要删除该料件编号吗？",
    enter_new_part_number_and_save: "输入新的料件编号点击保存。",
    part_moderation_status_is_not_reviewed: "料件的编辑状态必须是Reviewed。"
  },
  quote: {
    info: {
      quote_info: "报价概要",
      quote_number: "报价单号",
      title: "标题",
      quantity: "数量",
      product: "产品",
      product_bom_version: "BOM版本",
      product_type: "产品类型",
      customer: "客户",
      lead_time: "交期",
      expected_delivery_date: "客户目标交期",
      product_phase: "产品阶段",
      nsf_phase: "NSF评估阶段",
      process_order_category: "业务/订单类型",
      preferred_currency: "货币（偏好）",
      currency: "货币",
      exchange_rate: "汇率(USD/CNY)",
      add_purchased_parts_cost: 'Add purchased parts cost',
      tax_rate: "税率",
      comment: "备注",
      method: "报价方式",
      amount: "金额",
      deal_link: "Deal链接",
      deal_stage: "Deal阶段",
      deal_type: "Deal类型",
      urgency: "紧急",
      reorder: "再次下单？",
      owner: "业务员",
      tech_info_received: "收到技术文件",
      type: "类型",
      remark: "备注",
      status: "状态",
      is_taxed: "是否含税",
      created: "创建时间",
      tip: "请不要在标题中输入数量！相同标题的不同数量级的报价会被分为一组。",
      missing_quote_number: "缺少报价单号！",
      quote_cloned_success: "报价单信息复制成功！",
      quote_updated_success: "报价单信息更新成功！",
      cost_estimator_created: "成本估算已创建!",
      about_simple_quote_method: "关于打样单的报价方式，请参考该链接中描述的要求。",
      trade_type: "贸易类型",
      is_tax_included: "是否含税",
      unit_cost: "单价成本",
      unit_price: "单价售价",
      margin: "利润",
      subtotal: "总价",
      price_tax_excluded: "未税单价",
      total_tax: "税额",
      product_name: "产品",
      product_field_help_desc: "点击此处打开产品页面。",
      expires_date: "有效日期截止",
      payment_term: "付款条件",
      payment_term_note: "付款条件备注",
      expecting_completion_date: "期待报价完成时间",
      basecamp_todo_link: "Basecamp任务链接"
    },
    status: {
      open: "进行中",
      sent: "已发送",
      won: "关闭（成功）",
      lost: "关闭 （未成）",
      invalid: "无效",
      closed: "关闭"
    },
    types: {
      single_product: "产品",
      components: "料件",
      service: "服务",
      order_change: "订单变更"
    },
    methods: {
      simple: "简单报",
      normal: "正式报价",
      estimate: "估价（询盘）",
      priced: "定价",
      simple_option_desc: "正式报价，快速报，可能没有软成本明细",
      normal_option_desc: "详细的且拥有完整的硬成本和软成本",
      estimate_option_desc: "简单估算且不能作为订单依据的",
      priced_option_desc: "一般在NSF:S4及以上的阶段，且符合定价逻辑"
    },
    prices: {
      tax_include: "含税",
      tax_exclude: "不含税"
    },
    tabs: {
      items: "行项"
    },
    margin_setting: {
      quote_info: "报价表概要",
      price: "价格",
      total: "总金额",
      unit_price: "单价",
      gross_profit: "利润",
      net_profit: "净利润",
      total_cost: "总成本（不含税额）",
      total_cost_all: "总成本（含税额）",
      tax: "进项税",
      overall_margin: "总体利润",
      overall_margin_2: "利润率（税额计入成本）",
      test_margin_setting: "利润设置",
      margin_setting_breakdown: "利润设置分解",
      table_col_category: "分组",
      table_col_subcategory: "分项",
      table_col_margin_percent: "利润（%）",
      table_col_margin: "利润",
      table_col_price: "价格",
      table_col_unit_cost: "单位成本（不含税）",
      table_col_unit_cost_taxed: "单位成本（含税）",
      table_col_sale_tax: "销项税",
      table_col_unit_price: "单价（不含税）",
      table_col_unit_price_taxed: "单价（含税）",
      table_col_remark: "备注",
      table_col_cost: "成本（不含税）",
      table_time: "时间",
      table_total: "总金额",
      table_user: "用户",
      table_action: "操作",
      cost_breakdown: "成本分解总览",
      additional_expenses: "额外费用",
      cost_breakdown_summary_expenses: "成本分解总览和额外的费用",
      other_expenses: "其他费用",
      expenses: {
        qc_cost: "质量成本",
        company_expenses: "公司运营费用分摊"
      },
      summary_total_cost_help: "总体成本即后台估算成本，不包含税、额外的质量成本和公司费用分摊。",
      summary_gross_profit_help: "利润等于总成本乘以利润百分比。",
      summary_other_expense_help: "其他费用包含额外的质量成本和公司费用分摊。",
      summary_tax_help: "此处税为从后台估算的成本中提取出来的税额。",
      currencyTitle: "展示币种",
      history: "查看历史",
      historyTitle: "选择历史时间"
    },
    widgets: {
      details_link: "详细",
      date: "日期",
      lead_time: "交期",
      expected_delivery_date: "预交付日期",
      total_cost: "总成本",
      quantity: "数量",
      cost_estimation_title: "成本估算",
      create_cost_estimation: "创建成本估算",
      re_create_cost_estimation: "重新创建成本估算",
      margin_setting: "利润设置",
      overall_margin: "总体利润",
      qc_cost: "QC成本",
      unit_cost: "单位成本",
      company_expenses: "公司费用分摊",
      discount: "折扣",
      amount: "总价",
      create_margin_setting: "创建利润设置",
      related_quotes: "相关报价单",
      create_a_quote_form_this_one: "复制报价单",
      select_cost_estimator: "选择关联一个成本估算",
      find_cost_estimator_title: "选择一个成本估算",
      unit_price: "单价（含税）",
      quote_activities_timeline: {
        title: "报价活动时间表",
        display_toggle_btn_text_more: "查看更多",
        display_toggle_btn_text_less: "收起",
        cost_estimate_submits: {
          description: "提交了{name}成本评估: {note}",
          materials: "物料采购",
          sales_activities: "销售",
          pm_activities: "PM",
          qc_activities: "QC",
          ee_activities: "EE",
          me_activities: "ME",
          assembly_activities: "生产组装",
          warehouse_activities: "仓库",
          scm_activities: "SCM",
          logistics_activities: "物流"
        },
        state_workflow: {
          description: "状态从{from}切换到{to}",
          created: "创建",
          pending_cost_submissions: "等待成本评估",
          cost_submitted: "成本已提交",
          cost_estimate_pending_approval: "等待成本审核",
          cost_estimate_submitted: "成本已提交",
          closed: "已关闭",
          pending_cost_approval: "等待成本审核",
          pending_margin_submission: "利润设置",
          margin_review: "利润评估"
        }
      }
    },
    items: {
      sync_to_hubspot: "发送行项到HubSpot",
      new_item: "添加行项"
    },
    search_from_title_placeholder: '从报价单标题内查询',
    search_quote_number_placeholder: '输入报价单号查询',
    search_quote_method_placeholder: '选择报价方式过滤',
    search_customer_placeholder: '通过客户进行查找',
    search_people_placeholder: '通过报价单业务员进行查找',
    find_people_placeholder: '输入业务员信息',
    select_quote_method: '选择报价方式',
    select_quote_status: '选择报价单状态过滤',
    search_go: '过滤',
    reopen: "重新打开",
    title_is_required: '标题是必填项',
    method_is_required: '报价方式是必填项',
    owner_is_required: '业务员是必选项',
    trade_type_is_required: '贸易类型是必选项',
    nsf_phase_is_required: "NSF是必选项",
    process_order_category_is_required: "业务/订单类型是必选项",
    click_open_hubspot_quote_page: "点击打开HubSpot报价单页面",
    create_order_from_quote: "转订单",
    status_is_required: "状态是必选项",
    expires_date_is_required: "过期截止日是必填项",
    customer_is_required: "客户是必填项",
    currency_is_required: "货币是必填项",
    type_is_required: "类型是必选项",
    enter_price_with_tax_desc: "价格含税",
    creating_order_on_quote_not_won_error: "报价单未成单关闭，无法转订单!",
    create_estimate_pdf: "生成估价（询盘）PDF",
    group_status_activated: "已激活",
    group_status_invalidated: "已无效",
    group_status_drafting: "正在报价",
    group_status_closed: "已关闭",
    quantity_is_required: "数量是必填项",
    exchange_rate_is_required: "汇率是必填项",
    quote_created_success_message: "报价单创建成功！",
    list_is_empty: "列表是空的。",
    cost_estimator_missing_manufacturer_part_error: "请确保料件信息在产品页面的技术数据中已关联。",
    select_manufacturer_part_bom: "选择BOM",
    bom_is_required: "BOM是必填项",
    item_type_referenced_type: "选择类型",
    item_type_ref_product: "产品",
    item_type_ref_manufacturer_part: "料件",
    item_type_ref_fee: "费用",
    sync_hubspot: "创建或更新HubSpot报价单",
    link_to_deal: "链接到Deal",
    back_to_quote_page: "回到报价页面",
    hubspot_deal_using_different_currency_message: "Deal使用了不同的货币: %s。是否忘记修改Hubspot中Deal的货币了？",
    show_more_hubspot_quote_template: "查看更多",
    select_quote_type_placeholder: "选择报价类型",
    item_prevent_editing_parent_associated: "该行项与订单变更的行项关联着，修改该项会更新订单变更行项的值以保持其金额是统一的。",
    creating_order_missing_items: "由于报价单缺少行项，将无法转HubSpot报价单或者订单。",
    expecting_completion_date_is_required: "期待报价完成时间是必填项。",
    basecamp_todo_link_desc: "确保Robot (itas@nexpcb.com）用户已添加到Basecamp项目中，将报价信息更新自动同步到Basecamp。",
    basecamp_todo_link_not_correct: "Basecamp todo 链接格式不正确"
  },
  order: {
    order_info_head: "订单信息",
    title: "标题",
    search_go: "搜索",
    order_number_length_exceeded: "订单编号长度超出限制",
    enter_order_number_desc: "输入订单号查询",
    search_customer_desc: "输入客户信息查询",
    search_accounting_belongs: "选型所属公司",
    short_description_is_required: "工单描述为必填项",
    product_phase_is_required: "产品阶段是必填项",
    nsf_phase_is_required: "NSF是必填项",
    process_order_category_is_required: "业务/订单类型是必选项",
    product_type_is_required: "产品类型是必填项",
    order_type_is_required: "订单类型是必填项",
    new_order: "新订单",
    quote_reference: "关联报价单",
    short_description: "工单描述",
    quote_reference_desc: "点击此处查看报价单",
    short_description_desc: "ERP使用工单描述字段",
    order_number: "订单号(SO)",
    domestic_export_type: "贸易类型",
    domestic_export_type_domestic: "销售订单（国内）",
    domestic_export_type_export: "出口订单",
    customer_order_number: "客户订单号(PO)",
    customer: "客户",
    created_date: "创建时间",
    order_date: "下单日期",
    order_type: "订单类型",
    order_type_select_placeholder: "选择订单类型",
    order_status: "订单状态",
    product_stage: "产品阶段",
    product_type: "产品类型",
    nsf_phase: "NSF评估阶段",
    process_order_category: "业务/订单类型",
    product_stage_select_placeholder: "选择产品阶段",
    nsf_phase_select_placeholder: '选择NSF阶段',
    process_order_category_select_placeholder: '选择业务/订单类型',
    product_type_select_placeholder: '选择产品类型',
    shipping_address: "地址",
    accounting_belongs: "所属公司",
    currency: "币种",
    exchange_rate: "汇率",
    sales_person: "业务人员",
    remark: "备注",
    order_items: "订单行项",
    product_number: "产品编号",
    product: "产品名称",
    quantity: "数量",
    unit_price: "单位售价",
    unit_cost: "单位成本",
    subtotal: "Subtotal",
    delivery_date: "预交货日期",
    delivery_date_is_required: "预交货日期是必填项。",
    actions: "操作",
    total: "总共",
    add_item: "添加行项",
    term: "Term",
    sale_style: "出货方式",
    sale_style_from_warehouse: "从仓库出货",
    sale_style_from_3rdparty: "第三方出货",
    order_already_in_erp_msg: "该订单信息已经同步至ERP！",
    order_already_in_qbo_msg: '该订单已经同步到QBO的Estimate',
    order_item_form: "订单行项表单",
    send_order_to_erp: "发送订单到ERP",
    send_order_to_qbo: "更新QuickBooks订单",
    address_field_not_yet_available: "由于数据原因，地址字段还未启用。",
    bom_version: "BOM版本",
    is_tax_included: "单价是否含税",
    tax_rate: "税率",
    manufacturer_part: "物料",
    is_manufactured: "生产",
    margin: "利润",
    missing_data_error: "缺失！",
    missing_part_or_version: "缺失物料关系或者版本号！",
    total_tax: "税额",
    price_tax_excluded: "单价（未税）",
    subtotal_tax_excluded: "未税总价",
    customer_should_have_account_number: "必须生成客户编码，然后才能将订单同步到ERP",
    order_validate_before_send_to_erp: "请先完善订单内容，再同步至ERP",
    created_by_person: "制单人",
    select_customer_message: "请选择客户信息",
    creator_missing_required_erp_id: "制单人缺失ERP账号ID",
    order_reason: "订单原因",
    order_reason_is_required: "订单原因是必填项",
    no_ref: "无",
    quoted: "已报价",
    reorder: "返单（Re-order）",
    description_is_required: "描述是必填项",
    accounting_company_is_required: "所属公司是必填项",
    date_is_required: "下单日期是必填项",
    owner_is_required: "业务人员是必填项",
    exchange_rate_is_required: "汇率是必填项",
    order_change_reasoning: "变更原因",
    order_change_reasoning_is_required: "变更原因是必填项",
    engineering_craft: "工程和工艺相关",
    order_change_fees: "费用",
    order_change_others: "其他原因",
    order_item_change: "订单行项变更",
    order_item_product_qty_change: "产品或配件数量变更",
    bom_changed: "BOM变更",
    design_changed: "设计变更",
    shipping: "发货",
    over_changed: "多收（退款）",
    exchange_rate_changed: "汇率变动",
    tax: "税",
    delivery_date_changed: "交期变动（加急）",
    service_agreement_changed: "服务条款变更",
    change_reason_others: "其他原因",
    additional_fee_description: "描述",
    additional_fee_description_is_required: "描述是必填项",
    invoice_number: "Invoice #",
    additional_fee_cost: "成本",
    additional_fee_price: "价格",
    additional_fee_qty: "数量",
    add_order_change_fee: "添加订单变更费用",
    additional_order_change_items: "费用增减",
    order_change_modal_title: "订单变更费用填写",
    additional_fee: "费用",
    currency_is_required: "货币是必选项",
    fee_design: "设计费",
    fee_design_desc: "额外的设计费用",
    fee_generic_service: "服务费",
    fee_generic_service_desc: "额外的服务费用",
    fee_purchase_refund: "采购退款",
    fee_purchase_refund_desc: "多收或者额外的采购退款",
    fee_tax: "税",
    fee_tax_desc: "税",
    fee_import_clearance: "清关费",
    fee_import_clearance_desc: "额外的清关费用",
    fee_operation: "手续费",
    fee_operation_desc: "额外的手续费",
    fee_extra_urgency: "加急费",
    fee_extra_urgency_desc: "额外的加急费",
    fee_labor: "人工费",
    fee_labor_desc: "额外的人工费",
    fee_shipping: "运费",
    fee_shipping_desc: "额外的运费",
    fee_bom_change: "BOM变更费用",
    fee_bom_change_desc: "额外的BOM变更费用",
    fee_storage: "仓储费用",
    fee_storage_desc: "额外的仓储费用",
    fee_fixture: "治具费用",
    fee_fixture_desc: "额外的治具费用",
    fee_exchange_rate_change: "汇率差价",
    fee_exchange_rate_change_desc: "因汇率变动产生的差价",
    additional_fee_is_required: "费用是必填项",
    additional_fee_title_is_required: "标题是必填项",
    additional_fee_qty_is_required: "数量是必填项",
    additional_fee_price_is_required: "价格是必填项",
    additional_fee_add_item: "添加费用",
    additional_fee_total: "总共",
    order_change_reasoning_message: "解释其他原因",
    change_reasonning_message_is_required: "请对原因做描述。",
    order_item_changes: "行项变更",
    order_change_records: "订单变更记录",
    additional_fee_create_quote: "创建报价单",
    additional_fee_save_apply: "保存并应用到订单",
    order_additional_fee_order_item_change_message: "该变更内容会需要修改订单的行项完成更新，且需要出库。",
    order_additional_fee_item_change_message: "该变更通过加扣款项（增减费用类型）更新，且不做出库。",
    manufacturer_part_is_required: "物料是必填项",
    bom_version_is_required: "BOM版本是必填项",
    additional_fee_delivery_date_is_required: "预计交付日期是必填项",
    additional_fee_status: "状态",
    additional_fee_status_description: "复核之后变更和费用会同步至ERP，美国公司订单会同时更新QuickBooks。",
    additional_fee_sync2erp: "同步至ERP",
    additional_fee_sync2qbo: "同步至Quickbooks",
    accumulated_amount: "累计金额",
    additional_fees: "其他费用",
    fee_type: "费用类型",
    price: "金额",
    check_associated_quote: "点击查看关联的报价单",
    order_change_record_quote_created: "已转报价",
    order_change_date_is_required: "收款日期是必填项",
    order_change_date: "收款日期（请在确认之后进行修改，确保月份一致）",
    order_change_sub_order_number: "子订单号",
    order_change_sub_order_number_desc: "为此变更做的新的ERP订单号",
    open: "未结案",
    closed: "已结案",
    invalid: "无效",
    address: "地址",
    pending_approval: "未复核",
    approved: "已复核",
    status: "单况",
    approval_status: "审核状态",
    prepays: "应收款（预收）",
    change_status_open: "未复核",
    change_status_approved: "已复核",
    change_status_invalided: "已无效",
    item_remark: "备注",
    item_remark_is_required: "备注是必填项",
    order_change_warning: "如果提供子订单号且与主订单号不一致，或者添加了行项变更会创建新的子订单！如有疑问请联系IT.",
    order_save_success: "订单保存成功。"
  },
  cost: {
    summary: "Summary",
    currency: "币种",
    delete_tip: "确认删除此行项么？",
    new_assembled_part_cost_estimator: "新建成本估算",
    assembled_part_cost_estimator_info: "成本估算器信息",
    manufacturer_part: "料件",
    part_cost_form: {
      title: "标题",
      part: "Part",
      assembled_part: "成品、半成品",
      bom: "BOM",
      product: "产品",
      bom_version: "BOM 版本",
      quantity: "数量",
      volume_requested: "数量",
      currency: "货币",
      conversion_rate: "汇率",
      exchange_rate: "汇率",
      tax_rate: "税率",
      no_bom_set: "没有料件清单，你可以选择一个BOM来加载其料件清单。",
      import_materials_from_excel: "从Excel中导入料件清单",
      export_materials_to_excel: "导出至Excel",
      submit_estimates: "提交结果",
      load_octopart_components_prices: "加载Octopart料件价格",
      load_erp_components_avg_costs: "加载ERP料件平均成本",
      quantity_change_tip: "选择报价组中的另外一个数量级。",
      systemQuote: "系统报价",
      std_cost_refresh: "同步标准成本",
      bom_draft_tip: "当前选中BOM的子BOM版本都为Draft",
      bom_not_draft_tip: "当前选中BOM的子BOM版本为设置BOM时的版本",
      bom_tip: "该产品没有BOM， 请去创建",
      import_materials: "载入料件",
      back_to_cost_estimator_top_page: "回到成本估算器首页"
    },
    materials: {
      manufacturer_part_id: "料件id",
      quantity: "数量",
      price: "单价",
      currency: "货币",
      price_has_tax_or_not: "价格是否含税",
      price_has_tax: "含税",
      price_no_tax: "不含税",
      tax_rate: "税率",
      avg_cost: "月结平均成本(CNY)",
      standard_price: "标准价(CNY)",
      change_log: "修改日志",
      changed_by: "修改人员",
      changed_time: "修改时间",
      material_list_remove_confirm_title: "清除料件列表确认",
      delete_confirm: "确认删除这个料件么？",
      clear_list: "该操作会清除目前设置的料件信息以及相关的成本数据！点击确定继续执行。",
      has_materials: "料件列表已存在，确认要上传么？",
      table_title_validate: "导入表格表头必须包含Qty, MPN, Brand, Specification, Name, Price, Net qty, Taxed字段",
      quantity_placeholder: "请输入数量",
      quantity_tip: "设置批量数量，如果导入的BOM是数量级为1的清单",
      table_item_id_validate: "列表项id不一致，请清空列表后导入",
      price_high_tooltip: "该价格高于标准成本",
      price_source_usd: "该价格来源为美金",
      material_not_found_tooltip: "未在库内找到匹配的料件",
      category: "品类",
      top_five: "Top5",
      total: "总成本（未税）",
      net_cost_tip: '供应商成本或者历史采购标准价成本',
      risk_cost_tip: '工程师估算风险成本',
      net_cost: "净成本",
      quality_cost: "质量成本",
      risk_cost: '风险成本',
      total_rate: '税',
      grand_total: '累计',
      bom_import_model_content: "该BOM存在料件未设置损耗率！",
      bom_import_model_to: "前往修改",
      full_screen: '全屏',
      add_model_title: '新增供应商价格',
      button_new_supplier_quote: '新增供应商价格',
      button_add_supplier: '新增供应商',
      price_adjustment: '该价格为手动调整价格',
      assembled_part_cost_model_params_config_form: {
        title: {
          quote_strategy_setup: "报价策略设置",
          data_source_configuration: "数据源配置"
        },
        select: {
          customer_tier_select: "选择客户等级",
          preferred_suppliers: "首选供应商"
        },
        check_box: {
          use_mpq: "尽可能使用MPQ价格",
          enabled: "使用"
        },
        input: {
          purchase_histories: "采购历史",
          quote_created_date_limit: "Quote创建截止",
          date_after: "个月以内"
        },
        tips: {
          purchase_histories_tip: "之后会检索订单",
          preferred_suppliers_tip: "选择首选供应商和从其购买的料件",
          quote_created_tip: "之后会检索订单"
        },
        sources: {
          octopart: "Octopart",
          erp: "Erp",
          rfq: "Quotes from offline suppliers",
          quotes: "Quotes"
        },
        buttons: {
          button_cancel: "取消",
          button_save_and_start_quoting: "保存并开始报价"
        },
        customer_tier_labels: {
          prefer_online_price: "偏向使用线上价格",
          prefer_lowest_price: "偏向使用最低价格",
          prefer_most_recent_purchase_qty: "偏向使用最近采购同等数量级价格"
        }
      },
      displayNameInfoForm: {
        edit_title: "编辑料件信息",
        new_title: "新增料件"
      },
      priceInfoForm: {
        std_price: "标准进价",
        std_cost: "标准成本",
        avg_cost: "平均成本",
        mpq: "MPQ",
        last_purchased: "最近采购",
        suggested_purchase_qty: "建议采购数量",
        price: "价格",
        change_logs: "修改日志",
        tax_excluded: "未税",
        price_table: "价格表",
        adjustment_reason: '调价原因',
        other_reason: '备注',
        supplier: '供应商',
        quantity: '数量',
        note: '备注',
        reason: {
          customer_provided: '客供',
          engineer_risk_evaluation: '工程原因',
          market_price_increase: '加价（市场涨价）',
          market_price_cut: '降价（市场降价）',
          other: '其他'
        }
      },
      form: {
        cancel: '取消',
        save: '保存',
        net_quantity_tip: '若该料件在BOM中存在，净需求量会采用BOM中净需求量',
        quantity_tip: '若该料件在BOM中存在，数量会采用BOM中数量'
      },
      purchased_parts_cost_title: '料件成本估算',
      stock_availablity_filter: {
        stock_empty: '零库存',
        stock_available: '库存大于0',
        stock_greater_than_qty: '库存数量大于需求数量'
      }
    },
    cost_summary: {
      total_cost: "总成本",
      tax: "税",
      amount_taxed: "含税总成本",
      unit_cost: "单价",
      unit_cost_taxed: "含税单价",
      scrap_amount: "质量成本"
    },
    pricing: {
      change_log: "价格修改日志",
      category_setup: "设置报价策略",
      automatic_price: "系统报价",
      success: "价格已经自动生成，请查看.",
      start: "保存并开始报价",
      cancel: "取消",
      month_ago: "个月内",
      enabled: "启用",
      date_since: "自当前日期",
      manage_sources: "价格来源设置",
      use_mpq_price: "尽可能的尝试使用与MPQ量级相同的价格报价",
      select_customer_tier: "客户等级",
      sources: {
        quote: {
          name: "历史报价单"
        },
        erp: {
          name: "ERP",
          purchase_history: "采购历史",
          purchase_history_tooltip: "价格数据取值采购订单",
          supplier: "供应商",
          supplier_select: "只取用选中供应商的采购订单的价格",
          fallback_option: "当未匹配到合适采购记录时，采用",
          fallback_option_help: "选择当没有合适的采购记录匹配到时的出价方案。",
          standard_cost: "先使用标准成本，再平均成本",
          avg_cost: "先使用平均成本，再标准成本"
        },
        octopart: {
          name: "Octopart",
          supplier: "供应商",
          supplier_select: "只选取选中供应商的价格"
        },
        rfq: {
          name: "供应商询价",
          supplier: "供应商",
          supplier_select: "只选取选中供应商的价格"
        }
      }
    },
    pcb_cost: {
      title: "PCB 成本估算器",
      edit_spec: "编辑电路板规格参数",
      currency_tip: "* 使用CNY单位报价.",
      urgency_days_tip: "提前于标准",
      history_title: "报价历史",
      calculate_title: "计算器",
      pcb_cost_form: {
        quantity: "数量",
        impedence_test: "阻抗测试",
        service_fee: "服务费",
        urgency_days: "加急天数",
        details: "明细",
        standard_time: "标准交期",
        board_cost: "板子成本",
        express_fee: "快递费",
        urgency_fee: "加急费",
        calculated_price: "总价",
        working_days: "工作日"
      },
      button: {
        calculate: "计算",
        save: "保存",
        calculate_history: "查看相同板子的报价历史结果"
      }
    },
    costed_bom: {
      purchased_parts_cost: '采购件成本',
      add_purchased_parts_cost: '采购件成本',
      soft_hard_cost: '软硬成本比例',
      total_cost_components: '总成本构成比例',
      recurring: 'Recurring/Non-recurring',
      costed_bom_view: '成本BOM视图',
      summary_view: '概览视图',
      parts_form: {
        level: '层级',
        name: '描述',
        line_quantity: '单位用量',
        net_quantity: '净需求量',
        total_quantity: '总需求量',
        unit_price: '单价',
        net_amount: '净成本',
        scrap_amount: '质量成本',
        amount: '总成本',
        action: '操作',
        tip: '该料件不在BOM中'
      }
    },
    reports: {
      backend_soft_cost: '软成本',
      backend_hard_cost: '硬成本',
      backend_scrap_cost: '质量成本',
      backend_engineering_cost: '工程师成本',
      backend_production_cost: '生产成本',
      recurring_cost: '重复成本',
      non_recurring_cost: '一次性成本',
      mechanical_part: '结构料件',
      circuit_board: '电路光板',
      express_cost: '物流成本',
      electronic_part: '电子料件',
      assembled_part: '成品/半成品'
    }
  },
  homepage: {
    aggregated_sum: {
      total_quotes_won: "Total Number of quotes won",
      total_amount_quoted: "Successful quoted amount",
      total_no_of_products: "All time total number of products",
      total_ordered_amount: "Total ordered amount"
    },
    recent_activities: {
      headers: {
        quotes: "报价",
        products: "产品",
        orders: "订单",
        customers: "客户",
        manufacturer_parts: "料件、成品和半成品",
        audit_history: "更新记录",
        costEstimators: "成本估算器"
      },
      title: "标题",
      status: "状态",
      updated_at: "最近更新时间",
      more: "更多的",
      account_name: "姓名",
      account_number: "帐号",
      product_name: "产品名称",
      product_type: "产品类别",
      display_name: "显示名称",
      specification: "规格",
      audit_entity: "实体",
      audit_event: "操作",
      audit_action_by: "操作者",
      created_at: "创建日期",
      bom_name: "姓名",
      quantity: "数量"
    }
  },
  account: {
    search: "搜索客户",
    new: '载入客户',
    search_placeholder: '输入公司名称查询...',
    attribution: "归属",
    list_form: {
      name: "名称",
      short_code: "缩写",
      short_name: "简称",
      account_number: "客户编号",
      crm_id: "CRM ID",
      updated_at: "更新",
      action: "操作",
      delete_tip: "确认删除这个客户吗？",
      load_account: "载入客户",
      search_placeholder: "输入客户名称进行查询",
      attribution: "归属"
    },
    edit: {
      name: "显示/品牌名称",
      fullname: "全称/注册名",
      report_name: "报告名称",
      report_name_desc: "用于报告展示，相同名称会被合并",
      short_code: '缩写',
      short_name: '简称',
      customer_information: '客供料信息',
      add_customer_information: '新增客供料',
      account_number: '客户编号',
      account_manager: '业务人员',
      company: '公司',
      country: "国家",
      category: "类型",
      preferred_currency: "货币偏好",
      attribution_is_required: "客户归属是必填项",
      country_is_required: "国家是必填项",
      company_is_required: "公司是必填项",
      category_is_required: "类型是必填项",
      preferred_currency_is_required: "货币是必填项",
      account_recent_activities: {
        show_more_data: "显示更多",
        show_less_data: "显示较少",
        headers: {
          products: "产品",
          orders: "订单",
          quotes: "报价"
        },
        products: {
          product_name: "产品名称",
          manufacturer_parts: "制造商零件"
        },
        order_and_quotes: {
          title: "标题",
          creation_date: "创建日期",
          status: "状态"
        }
      }
    },
    customer_information_form: {
      part_number: '料号',
      name: '名称',
      specification: '规格',
      brand: '原厂名称（品牌）',
      mpn: 'MPN',
      stock: '库存',
      material_state: '状态（料件）',
      customer_information_state: '状态（客供料）',
      action: '操作',
      status_on: '启用',
      status_off: '禁用'
    },
    click_to_access_account_info_message: "点击访问客户信息",
    external_relationship: "外部关联"
  },
  bom_hierarchy_nested_tree_editor: {
    heading: "通过拖拽来编辑 BOM 的结构",
    local_bom_file_rows_found: "发现未保存的 BOM 结构编辑内容",
    confirm_to_load_bom_file_from_local: "发现一个在编辑状态未保存的 BOM 结构数据，你想要继续编辑吗？",
    local_bom_file_rows_found_modal_ok_text: "继续编辑",
    local_bom_file_rows_found_modal_cancel_text: "放弃并删除未保存数据",
    error_panel: "错误面板",
    error_tip_1: "在上次保存过程中发现以下错误：",
    error_tip_2: "修改之后保存即可消除错误"
  },
  product: {
    info: {
      product_name: "产品名称",
      product_alias: "产品别名",
      product_code: "ERP编码",
      english_name: "英文名",
      english_name_help: "与国外客户达成一致的英文名，会用于例如QBO的外部系统的产品名称显示",
      product_type: "产品类型",
      product_model: "产品型号",
      file_type: "文件类型",
      file_description: "文件描述",
      upload_file: "上传文件",
      file_type_description_attributes_are_required: "文件类型和文件描述字段是必填项。",
      category: "分类",
      unit_price: "售价",
      unit_cost: "成本",
      margin: "利润",
      currency: "货币",
      lifecycle_status: "状态",
      product_number: "产品编号",
      product_type_product: "产品",
      product_type_service: "服务",
      product_status_active: "激活",
      product_status_discontinued: "停用",
      customer: "客户",
      webpagelink: "网页链接"
    },
    tabs: {
      attachments: "附件",
      orders: "订单",
      projects: "项目",
      quotes: "报价",
      pcbs: "PCB",
      boms: "BOM"
    },
    plugins: {
      quote: {
        add_new_quote: "新增报价单",
        empty: "没有报价数据。",
        table: {
          title: "项目名称",
          quantity: "数量",
          expected_delivery_date: "预交期",
          owner: "Owner",
          status: "状态",
          created: "创建日期",
          actions: "操作"
        }
      },
      orders: {
        add_new_order: "新增订单",
        empty: "没有订单数据。"
      },
      bom: {
        table: {
          title: "BOM",
          part_name: "料件",
          version: "当前版本",
          note: "最新日志",
          actions: "操作"
        },
        found_new_changes: "发现有变更",
        search_placeholder: '请输入BOM名称进行搜索'
      },
      manufacturer_part: {
        add_new_part: "新增料件",
        remove_modal: {
          title: "移除料件",
          warning: "该部件将不再与该产品相关联。",
          confirm: "你想继续吗？",
          button_text: "是的，继续"
        }
      }

    },
    remove_association_confirmation: "你正在删除关联，点击确定移除。",
    associate_bom: "关联BOM",
    attachments: {
      description: "那些需要被管理起来的文档资产。",
      img_title: "图片预览"
    },
    search: "搜索产品",
    click_here_to_view_product: "点击此处查看产品信息",
    new_product: "新增产品",
    product_number: "产品编号",
    product_name: "产品名称",
    product_type: "类型 ",
    category: "分类",
    status: "状态",
    created_at: "创建日期",
    enter_product_name: "输入产品名称",
    enter_product_number: "输入产品编号",
    enter_product_model: "输入产品型号",
    reference_assembled_part_help_text: "选择一个成品或半成品料件进行关联。",
    english_name_is_required: "英文名称是必填项（用于Quickbooks）。"
  },
  pcb: {
    list: {
      title: "电路光板"
    },
    button: {
      new_pcb: "新增电路板",
      quote_pcb: "去估算成本",
      save_pcb_spec: "保存PCB规格"
    },
    form: {
      board_name: "名称（英文）",
      chinese_name: "名称（中文）",
      specification: "规格型号",
      description: "描述",
      moderation: "状态",
      dimension: "面积",
      width: "宽",
      height: "高",
      layers: "层数",
      materials: "材料",
      finished_thickness: "Finished thickness",
      legend_color: "Legend color",
      copper_weight: "Copper weight",
      min_trance_space_mil: "Min. trace/space(mil)",
      top_side_bottom_side: "Top side/bottom side",
      measurement_unit: "Measurement unit",
      different_designs: "Different design",
      pcb_standard: "PCB standard",
      solider_mask: "Solider mask",
      surface_finished: "Surface finished",
      min_hole_sizes: "Min. hole sizes",
      board_name_placeholder: "例如 LPCXpresso55S69 Circuit Board rev A1",
      description_placeholder: "提供任何你觉得可以描述该板子的信息...",
      impedance_test: {
        field_name: '阻抗测试',
        yes: '是的',
        no: '不'
      }
    },
    image: "图片",
    edit: {
      title: "电路板信息",
      specifications: "电路板规格参数"
    },
    new: {
      title: "新建电路板信息"
    },
    search: "搜索PCB"
  },
  electronic: {
    button: {
      new_electronic_part: "新增电子料件",
      octopart_add: "新增到Pangu"
    },
    octopart_search: {
      performan_mpn_search_info: '以MPN查询Octopart。'
    }
  },
  mechanical: {
    list: {
      title: "结构料件"
    },
    button: {
      new_mechanical: "新增结构件"
    },
    form: {
      category: "分类",
      name: "名称（英文）",
      chinese_name: "名称（中文）",
      specification: "规格型号",
      description: "描述",
      moderation: "状态",
      name_placeholder: "例如 RS2下壳",
      description_placeholder: "提供任何你觉得可以描述该料件的信息..."
    },
    image: "图片",
    edit: {
      title: "结构件信息"
    },
    new: {
      title: "新建结构件信息"
    }
  },
  assembled: {
    list: {
      title: "PCBA，成品和半成品"
    },
    button: {
      new_assembled: "新增组装件"
    },
    form: {
      category: "分类",
      name: "名称（英文）",
      chinese_name: "名称（中文）",
      specification: "规格型号",
      description: "描述",
      moderation: "状态",
      name_placeholder: "例如 RS2半成品",
      description_placeholder: "提供任何你觉得可以描述该板子的信息..."
    },
    image: "图片",
    edit: {
      title: "组装件信息"
    },
    new: {
      title: "新建组装件信息"
    }
  },
  material_line_items: {
    display_name: '简述信息',
    net_qty: '净需求量',
    net_cost: '净成本',
    price: '价格 (未税)',
    amount: '总金额',
    tax: '税',
    specification: '规格型号',
    note: '备注',
    designator: '位号',
    stock: '库存',
    all_qty: '总需求量',
    supplier_price: '供应商报价',
    risk_amount: '风险成本'
  },
  quality: {
    scrap: {
      title: "损耗率",
      no_scrap_check: "只显示未设置损耗率",
      scrap_tip: "已设置料件损耗率",
      history_model_title: "损耗率修改记录",
      edit_model_title: "损耗率设置",
      edit_model_tip: "修改此处不会影响BOM的损耗率设置",
      load_default_scrap_rate: "加载通用损耗率"
    },
    scrap_list: {
      "search_placeholder": "请输入料号、MPN或料件名称进行查询"
    }
  },
  workflow: {
    state_badge: {
      pending: "等待"
    },
    status_title: 'Status',
    status: {
      created: 'Created',
      pending_cost_submissions: 'Pending cost submissions',
      cost_submitted: 'Cost submitted',
      pending_cost_approval: 'Pending cost approval',
      pending_margin_submission: 'Pending margin submission',
      margin_review: 'Margin review',
      approved: 'Approved',
      closed: 'Closed'
    }
  },
  task: {
    no_tasks: "你没有任务！",
    task_info: "任务信息",
    closure_notice: "这个任务将会在报价单关闭时自动完成。",
    go_to_quote_page: "进入报价页面。"
  },
  people: {
    fullname_cn: "名称",
    gender: "性别",
    department: "部门",
    email: "邮箱",
    country: "国家",
    erp_id: "ERP账号ID",
    erp_people_id: "ERP人员编号",
    new_people: "新增人员",
    mobile: "手机号",
    chinese_name: "中文名",
    english_name: "英文名",
    birthday: "生日",
    identities: "识别码",
    dingtalk_id: "钉钉用户ID",
    uuid: "UUID"
  },
  nsf: {
    engineering: "工程化阶段",
    npi: "新产品导入阶段",
    productization: "产品化阶段",
    industrialization: "产业化阶段",
    s1_desc: "试样，功能性验证",
    s2_desc: "试样，可制造性验证",
    s3_desc: "新产品导入，标准确定",
    s4_desc: "小批量试生产",
    s5_desc: "量产阶段",
    s6_desc: "产业化阶段"
  },
  process_order_category: {
    "1_label": "甲类",
    "1_desc": "通常是S6阶段的订单，目前一般指Emlid的非配件类订单，Kenitic护臂和PiShop的PiKIV等订单；是公司业务的关键订单，需要高度重视.",
    "2_label": "乙类",
    "2_desc": "通常是客户重复下的订单，产品和商业有很高的相似度，例如EA订单，此类订单需要考虑标准化、信息化和数字化处理, informatization, and digital processing.",
    "3_label": "丙类",
    "3_desc": "有高潜力值的订单，高潜力值包括当前订单可能存在亏损但是翻单存在高收益或者和公司发展战略匹配的订单.",
    "4_label": "丁类",
    "4_desc": "通常是打样订单，要求快速交付，以完成公司业绩为目标."
  },
  org: {
    accelerating_center: "加速中心",
    delivery_center: "交付中心",
    trading: "贸易",
    dm: "Display module (DM)",
    other: "其他",
    company_category_a: "A",
    company_category_b: "B",
    company_category_c: "C",
    company_category_d: "D",
    preferred_currency: "常用货币",
    company_category_a_desc: "行业领军企业，当年合同额度大于等于1000万RMB",
    company_category_b_desc: "细分领域领军企业，单个产品合同额大于等于200万RMB",
    company_category_c_desc: "需要一个Proposal",
    company_category_d_desc: "来什么需求，交付什么需求",
    company_related_object: "关联数据"
  },
  error_notice: {
    4220201: '料件已存在，无法重复添加.',
    4220601: '由于某些限制，不允许删除料号.',
    4220602: '由于某些限制，不允许生成料号.',
    4220603: '不允许删除料件.',
    4220604: '找到重复的MPN和品牌.',
    4220605: '缺少料件类别.',
    4220606: '未找到料件类别.',
    4220607: '客户提供的料号应与规则匹配：{PN}-{SHORT_CODE}.',
    4220608: '缺少料号.',
    4220502: '当前版本的BOM在ERP中已存在，不允许同步.',
    4220701: '缺少必需的帐户名属性.',
    4220702: '缩写已被使用.',
    1000702: '缺少订单号！',
    1000703: '订单号已经存在！',
    1000608: "尝试添加料件到通用替代关系与另外一个通用替代集中的料件合有重叠，需要进行合并。",
    1000801: "一个料件无法关联到不同产品, 此料件已经关联了产品 {product_name}",
    9000101: "Basecamp集成用户, Robot（邮箱itas@nexpcb.com）必须添加项目中。"
  }
}
